import Call from '../Call.v2';
import {objToQs} from '../Utils';

const BidderNetworkPerfromance = {
    get(type, filters, path = '') {
        return Call(`bidder/networkPerformance/${type}/${path}?${objToQs(filters)}`);
    },

    getHourly(filters, path = '') {
        return Call(`bidder/networkPerformance/hourly/${path}?${objToQs(filters)}`);
    },

    getAffids(type, filters) {
        return Call(`bidder/networkPerformance/${type}/affids?${objToQs(filters)}`);
    },
};

export default BidderNetworkPerfromance;



// WEBPACK FOOTER //
// ./src/services/API/components/BidderNetworkPerformance.v2.js